import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {applyOptions} from '../productPurchase/ProductOptionsPicker';
import ProductOptionsPicker from '../productPurchase/ProductOptionsPicker';
import Pricing from '../pricing/Pricing';
import Tooltip from '../tooltip/Tooltip';

import ChannelPrice from '../../containers/channelUtils/ChannelPrice';

export default class BaseVariant extends React.PureComponent {
  static propTypes = {
    price: PropTypes.number.isRequired,
    originalPrice: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array
  };

  static defaultProps = {
    options: []
  };

  static quantity = 1;

  componentWillMount() {
    const {options} = this.props;

    const selectedOptions = options.filter(it => it.select).map(it => it.id);

    this.updateOptions(selectedOptions);
  }

  componentWillReceiveProps(nextProps) {
    const {options, price, originalPrice} = nextProps;

    if (options !== this.props.options || price !== this.props.price || originalPrice !== this.props.originalPrice) {
      return this.updateOptions([], price, originalPrice);
    }
  }

  updateOptions = (selectedOptions, price = this.props.price, originalPrice = this.props.originalPrice) => {
    const {options} = this.props;

    const uniqueSelectedOptions = [...new Set(selectedOptions)];

    const appliedOptions = options.filter(it => uniqueSelectedOptions.includes(it.id));

    const totalCost = applyOptions(price, BaseVariant.quantity, appliedOptions);

    let originalTotalCost;
    if (originalPrice) {
      originalTotalCost = applyOptions(originalPrice, BaseVariant.quantity, appliedOptions);
    }

    this.setState({
      selectedOptions: uniqueSelectedOptions,
      totalCost,
      originalTotalCost,
    });

    this.props.onChange({
      options: uniqueSelectedOptions,
      quantity: BaseVariant.quantity,
      error: totalCost === 0 && 'section.generic.select-options'
    });

    this.props.onCostChange(totalCost);
  };

  render() {
    const {price, options} = this.props;
    const {selectedOptions, totalCost, originalTotalCost} = this.state;

    return (
      <div className="product-variant product-variant--base">
        {options.length > 0 && (
          <ProductOptionsPicker
            basePrice={price}
            quantity={BaseVariant.quantity}
            availableOptions={options}
            selectedOptionIds={selectedOptions}
            onChange={this.updateOptions}
          />
        )}

        <div className="product__price">
          <Pricing
            accented
            value={totalCost}
            originalValue={originalTotalCost}
          />

        </div>

        <div className="product__bonus">
          <FormattedMessage
            id="page.checkout.cashback.total"
            values={{amount: <ChannelPrice component="b" price={totalCost * 0.03}/>}}
          />

          <Tooltip
            content={<FormattedMessage id="page.checkout.cashback.tooltip.full"/>}
            open={this.state.openTooltip}
          >
            <div className='tooltip_trigger' onMouseLeave={() => this.setState({openTooltip: false})} onMouseEnter={() => this.setState({openTooltip: true})} />
          </Tooltip>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/BaseVariant.js